import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  Output,
  EventEmitter,
  AfterViewInit,
  OnChanges,
  AfterContentChecked
} from '@angular/core'
import { FormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs/Subject'
import { AuthorizeService } from 'app/service/authorize.service';
import { ExportExcelService } from '../../service/export-excel.service';

@Component({
  selector: 'app-company-ae-table',
  templateUrl: './company-ae-table.component.html',
  styleUrls: ['./company-ae-table.component.scss']
})
export class CompanyAeTableComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges, AfterContentChecked {
  @Output() createButtonClick: EventEmitter<any> = new EventEmitter()
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  @Input() printPage
  @Input() exportFunctions: Map<String, Function>
  @Output() emitEditCase: EventEmitter<any> = new EventEmitter()

  dtTrigger: Subject<any> = new Subject()
  companyaeTableOptions: DataTables.Settings = {}
  companyaeTableOptionsConfig: DataTables.Settings = {}

  listHeader = ['Team', 'Name', 'Market', 'Industry', 'Sector', 'Symbol', 'Default'];
  listTable = [];
  listAe = [];
  print = false
  initTableFirstTime = false
  name
  secSymbol
  divisionId

  asc = 1
  desc = -1

  constructor(
    private cpmService: CpmService,
    private excelService: ExportExcelService,
    private authorization: AuthorizeService,
  ) { }

  ngAfterContentChecked() {
    let x = document.getElementsByClassName('dataTables_scrollBody');
    if (x[0]) {
      if (x[0].scrollHeight > x[0].clientHeight) document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("scrollHeadInner");
      else document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("noScrollHeadInner");
    }
  }

  ngOnInit() {

    this.companyaeTableOptions = {
      autoWidth: false,
      paging: false,
      searching: true,
      info: false,
      scrollCollapse: true,
      language: {
        emptyTable: 'No information found'
      },
      columnDefs: [{
        targets: 6,
        visible: false
      }],
      order: [[6, 'asc']],
      destroy: true,
      scrollY: '350px'
    }

    this.companyaeTableOptionsConfig = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      destroy: true
    }

    this.getCompanyAEdata()

  }

  getDataTableConfig() {
    if (!this.printPage) {
      return this.companyaeTableOptions
    } else {
      return this.companyaeTableOptionsConfig
    }
  }
  rerender(): void {
    if (this.dtElement.dtInstance !== undefined) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
        this.dtTrigger.next()
      })
    }
  }
  async getCompanyAEdata() {
    this.drawDataTable();
    this.listAe = [];
    await this.cpmService.getAllAEList().then(success => {
      const listData = success
      if (listData !== null) {
        listData.map(obj => {
          obj.security.map(security => {
            const aeSecurity = security;
            this.divisionId = obj.divisionId;
            aeSecurity['department'] = obj.department;
            aeSecurity['divisionId'] = obj.divisionId;
            aeSecurity['id'] = obj.id;
            aeSecurity['firstNameThai'] = obj.firstNameThai;
            aeSecurity['lastNameThai'] = obj.lastNameThai;
            this.listAe.push(aeSecurity);
          })
        })
      }
    });
    this.drawDataTable();
  }

  drawDataTable() {
    this.rerender();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next()
  }
  ngOnChanges() {
  }

  editCase(id, divisionId) {
    const data = this.listAe.find(obj => obj.id === id)

    this.createButtonClick.emit({
      id: id,
      securitySymbol: data.securitySymbol,
      divisionId: divisionId
    })

  }

  createClick(divisionId) {
    this.createButtonClick.emit({
      id: null,
      securitySymbol: '',
      divisionId: divisionId,
    })
  }

  ngOnDestroy() {
    this.dtTrigger.unsubscribe();
  }
  get isUserHasEditPermission() {
    return (this.authorization.hasRole('CRM_AE_SUM'));
  }
  get getUserDivision() {
    return this.authorization.getUserDivision();
  }

  exportFunctionsCompanyAE() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();

    arrayOfFunctions.set(
      'excel',
      this.exportExcelCompanyAE(this.excelService, this.listAe)
    );
    return arrayOfFunctions;
  }

  exportExcelCompanyAE(service, listAe) {
    return function excelCompanyAE() {
      service.exportExcelComAE(listAe, 'Company AE')
    }
  }


}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/admin/company-ae-table/company-ae-table.component.ts